<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <todo-requirements>
        </todo-requirements> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import TodoRequirements from './todo-requirements'
export default {
    components: {
    TodoRequirements
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-requirements/base-requirements.vue